import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const UserCentricExperience = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/service-uiux.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">User-Centric Experience</h1>
                  <h2 id="sub_heading1">
                  A *user-centric experience* (UX) is the foundation of modern web design. It prioritizes the needs, expectations, and preferences of the users, ensuring that they have an intuitive, enjoyable, and efficient experience when interacting with a website or application. As digital environments evolve, businesses, content creators, and developers must understand the significance of creating designs that are tailored to their audience. Let’s explore the *user-centric experience*, why it’s important, and the best practices for creating an optimal user experience.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              What is a <span>User-Centric Experience ?</span>
              </h3>
              <p>
              A *user-centric experience* is a design philosophy that places the user at the center of the design and development process. It is based on the understanding that the success of any website or app is directly tied to how well it meets the needs and solves the problems of its users.

              </p>
              <p>
              User-centric design focuses on:{" "}
              </p>
                <ul>
                    <ul>
                        <li><b>Ease of use:</b>Websites and apps should be easy to navigate and understand.</li>
                        <li><b>Relevance: </b>Content should be personalized and highly relevant to the user.</li>
                        <li><b>Efficiency: </b>The user’s time should be respected with fast load times and simple, streamlined processes.</li>
                    </ul>
                </ul>
                <p>The goal is to create a seamless interaction that encourages users to stay longer, explore more, and, ultimately, convert—whether that’s through purchasing a product, subscribing to a service, or taking some other action.</p>
              <h4>Why is a User-Centric Experience Important?</h4>
              <ul>
                    <li><b>Increases Engagement:</b>A user-centric website fosters engagement by providing the content and features that users want or need. When users feel that a website understands their preferences, they are more likely to spend more time on the site, browse through multiple pages, and interact with content.
                    </li>
                    <li><b>Enhances Usability:</b>Websites and apps designed with the user in mind are more intuitive and easier to navigate. This reduces frustration and increases satisfaction, leading to repeat visits and positive feedback.</li>
                    <li><b>Improves Conversion Rates:</b>A positive user experience has a direct impact on conversion rates. By making the user journey smooth and straightforward, businesses can drive actions such as purchases, sign-ups, and contact form submissions.</li>
                    <li><b>Builds Brand Loyalty:</b>A website that offers a great user experience fosters trust and reliability. When users have a positive experience, they are more likely to return, share the website with others, and remain loyal to the brand.</li>
                    <li><b>Boosts SEO: </b>User-centric designs are often SEO-friendly. Features like fast load times, mobile optimization, and intuitive navigation contribute to better search engine rankings. Search engines like Google prioritize websites that deliver a good user experience.</li>
              </ul>
              <h4>Key Principles of User-Centric Design</h4>
              <ul>
                <li><b>Understand Your Users:</b> The first step in creating a user-centric experience is understanding who your users are, their goals, and the problems they need solving. This can be achieved</li>
                <li><b>Simplicity is Key:</b> A cluttered interface or overwhelming amount of content can confuse users. A clean, simple layout makes it easy for users to find what they’re looking for and reduces cognitive load. Use whitespace effectively and focus on core content.
                </li>                
                <li><b>Prioritize Navigation: </b> Navigation is crucial to user experience. It should be intuitive, simple, and easy to find.</li>                
                <li><b>Responsive and Accessible Design: </b>A user-centric website must perform well across a variety of devices and for all users, including those with disabilities. </li>                
                <li><b>Fast Load Times:</b> Slow websites drive users away. Speed is a crucial aspect of the user experience, particularly when users are impatient and expect quick results. Optimize images, minify scripts, and leverage caching to improve load times.</li>                
                <li><b>Personalization: </b> Personalized content, such as product recommendations or tailored messages, enhances the user experience. By utilizing user data responsibly, websites can create a more customized experience that feels more relevant and engaging.</li>                
                <li><b>Clear Calls-to-Action (CTAs):</b> The user journey should lead to clear, easily accessible calls-to-action (CTAs). Whether it's “Buy Now,” “Learn More,” or “Contact Us,” make sure these actions are prominently displayed and stand out from the rest of the content.</li>                
              </ul>
              <h4>Best Practices for Creating a User-Centric Experience</h4>
                    <ul>
                        <li><b>User Testing:</b> Regularly conduct usability testing with real users to identify pain points and areas of confusion. This will help you refine the user experience and ensure that the design meets the needs of the audience.
                        </li>
                        <li><b>Feedback Loops:</b> Create opportunities for users to provide feedback on their experience. Use surveys, contact forms, or live chat options to gather insights that can drive future improvements.</li>
                        <li><b>Adaptability: </b>The digital landscape evolves quickly, and user needs may change over time. Be prepared to adapt your design based on user feedback, new technologies, or shifts in your target audience’s behavior.</li>
                        <li><b>Optimize for Multiscreen Experiences: </b>With users accessing content across multiple devices, ensure that your design remains consistent and provides a great experience on desktops, tablets, and smartphones. Responsive design plays a major role in this.</li>
                        <li><b>Streamlined User Journeys: </b>Simplify the steps needed to complete an action. For example, if you're running an e-commerce site, reduce the steps from product selection to checkout. Remove unnecessary fields in forms, and make sure the process is fast and hassle-free.</li>
                    </ul>
              <h4>
              The Future of User-Centric Design
              </h4>
              <p>As technology advances, the demand for personalized and frictionless experiences will continue to grow. Artificial intelligence (AI), voice search, and augmented reality (AR) are just a few of the innovations that will shape the future of user-centric design. As users become more accustomed to intuitive interfaces and fast, responsive websites, businesses must stay ahead of the curve to provide innovative, seamless experiences.
              </p>
              <h4>Conclusion</h4>
              <p>
              A user-centric experience is not just a design choice; it is a fundamental aspect of creating successful, high-performing websites and applications. By prioritizing the needs of your users, you not only enhance engagement, usability, and conversions but also build lasting relationships with your audience.</p>
              <p>To achieve this, businesses and designers must listen to their users, streamline their interactions, and ensure that the experience remains intuitive, responsive, and tailored. In the end, creating a user-centric experience results in more satisfied users, higher retention rates, and a stronger brand reputation. The key to success in today’s digital landscape is clear: focus on the user, and the user will focus on you.</p>
            </div>
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default UserCentricExperience;
